import type {QueryParams} from '@/modules/common/context/QueryParams/models';
import type {QueryParamsSchema} from '@/modules/common/context/QueryParams/schema';

export const parseWithSchema = ({
  urlSearchParams,
  schema,
}: {
  urlSearchParams: URLSearchParams;
  schema: QueryParamsSchema;
}): QueryParams => {
  return Object.fromEntries(
    Object.entries(schema).map(([key, spec]) => {
      const queryValue = urlSearchParams.get(key);
      const parsedValue = spec.parse(queryValue);

      return [key, parsedValue];
    })
  ) as QueryParams; // @FIXME
};
